import { Injectable } from "@angular/core";
import { BehaviorSubject, shareReplay } from "rxjs";

import { StateService } from "./base-states/base-state";
import { ILiveQuizModel, ILiveQuizStateModel } from "../../shared/models/live-quiz.model";
import { LiveQuizService } from "../http-services/live-quiz.service";

const initialState: ILiveQuizStateModel = {
    recentComingQuiz$: new BehaviorSubject<ILiveQuizModel[]>([]),
    liveQuiz: []
};

@Injectable({
    providedIn: 'root'
})

export class LiveQuizStateService extends StateService<ILiveQuizStateModel> {

    constructor(
        private readonly liveQuizService: LiveQuizService,
    ) {
        super({ ...initialState });
    }

    updateLiveQuizState(): void {
        this.liveQuizService.recentComingEvents().pipe(shareReplay(1)).subscribe({
            next: (data) => this.state.recentComingQuiz$.next(data ?? []),
            error: (err) => console.error('Failed to load recent coming events:', err)
        });
    }

    resetState() {
        this.setState({ ...initialState })
    }

    getRecentComingEvents(): BehaviorSubject<ILiveQuizModel[]> {
        return this.state.recentComingQuiz$;
    }
}